import { render, staticRenderFns } from "./AnswerListItem.vue?vue&type=template&id=ab2c8fc8&scoped=true&"
import script from "./AnswerListItem.vue?vue&type=script&lang=js&"
export * from "./AnswerListItem.vue?vue&type=script&lang=js&"
import style0 from "./AnswerListItem.vue?vue&type=style&index=0&id=ab2c8fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2c8fc8",
  null
  
)

export default component.exports